import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"

function BehavioursBreakdown({ exportEndpoint, data, appliedFilters, subtitleKey, sampleSize }) {
  const barChartData = {
    categories: [],
    bars: []
  }

  const singleDataItem = {
    data: [],
    showInLegend: false
  }

  data.forEach(d => {
    barChartData.categories.push(d.itemName)
    singleDataItem.data.push(d.percentage)
  })
  barChartData.bars.push(singleDataItem)

  const titleKey="Widgets.BehavioursBreakdown.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.BehaviourBreakdown.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Widgets.BehavioursBreakdown.Responses"
        xAxisTitle="Widgets.BehavioursBreakdown.Scale"
        chartType="column"
        isPercentageBased
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

BehavioursBreakdown.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.string, PropTypes.number).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default BehavioursBreakdown



// WEBPACK FOOTER //
// ./src/components/widgets/BehavioursBreakdown.jsx